import { TMC_LOGO } from "./landingAssets";

export const DEFAULT_LANDING = {
  discord_link: "",
  telegram_link: "",
  telegram_link_2: "",
};

// Inner page script — PLAIN JS ONLY. Must NOT contain backticks or ${ }.
const PAGE_JS = `
var I18N = {
  pl: {
    nav_join: "Dołącz",
    hero_badge: "DYSCYPLINA · CIERPLIWOŚĆ · KONSEKWENCJA",
    hero_tag: "Akademia tradingu, sygnały i społeczność, która uczy Cię handlować świadomie.",
    hero_cta1: "Dołącz teraz",
    hero_cta2: "Napisz do lidera",
    about_h: "Kim jesteśmy",
    about_p: "The Money Club (TMC) to społeczność i akademia tradingu. Uczymy od podstaw — od rejestracji konta i MT5, przez strukturę rynku, płynność i Order Blocks, po kompletny framework TMC. Dajemy realną wiedzę, sygnały rynkowe i wsparcie ludzi, którzy handlują na poważnie.",
    offer_h: "Co od nas dostajesz",
    offer: [
      ["Sygnały", "Sygnały na XAUUSD, indeksy i forex prosto na Discorda — z poziomami wejścia, SL i TP."],
      ["Akademia", "Kompletny kurs krok po kroku: MT5, TradingView, świece, struktura rynku, Order Blocks, FVG i analiza MTF."],
      ["Społeczność", "Aktywna społeczność traderów, codzienne wsparcie i wspólna analiza rynku."],
      ["Zarządzanie ryzykiem", "Zasada 1% ryzyka, RR i position sizing — fundament przetrwania na rynku."],
      ["Psychologia", "Praca nad FOMO, revenge tradingiem i dyscypliną — najtrudniejszy, ale najważniejszy moduł."],
      ["Framework TMC", "Kompletny proces dnia tradera TMC — od analizy, przez plan, po recenzję i dziennik."]
    ],
    join_h: "Jak dołączyć",
    s4_h: "Dołącz do naszej społeczności",
    s4_p: "Aby uzyskać więcej informacji oraz dołączyć do naszej społeczności, odezwij się do swojego lidera poprzez poniższy link.",
    s4_cta: "Napisz do lidera",
    final_h: "Gotowy, żeby zacząć?",
    final_p: "Dołącz do The Money Club i zacznij handlować z planem, wiedzą i wsparciem społeczności.",
    disclaimer: "The Money Club ma charakter edukacyjny i informacyjny i nie stanowi indywidualnej porady inwestycyjnej. Trading wiąże się z ryzykiem utraty kapitału."
  },
  en: {
    nav_join: "Join",
    hero_badge: "DISCIPLINE · PATIENCE · CONSISTENCY",
    hero_tag: "A trading academy, signals and a community that teaches you to trade with discipline.",
    hero_cta1: "Join now",
    hero_cta2: "Message your leader",
    about_h: "Who we are",
    about_p: "The Money Club (TMC) is a trading community and academy. We teach from the ground up — from account and MT5 setup, through market structure, liquidity and Order Blocks, to the complete TMC framework. We give you real knowledge, market signals and support from people who trade seriously.",
    offer_h: "What you get",
    offer: [
      ["Signals", "Signals on XAUUSD, indices and forex straight to Discord — with entry, SL and TP levels."],
      ["Academy", "A complete step-by-step course: MT5, TradingView, candles, market structure, Order Blocks, FVG and MTF analysis."],
      ["Community", "An active trader community, daily support and shared market analysis."],
      ["Risk management", "The 1% risk rule, RR and position sizing — the foundation of surviving in the market."],
      ["Psychology", "Working on FOMO, revenge trading and discipline — the hardest but most important module."],
      ["TMC Framework", "The complete daily process of a TMC trader — from analysis, through the plan, to review and journaling."]
    ],
    join_h: "How to join",
    s4_h: "Join our community",
    s4_p: "To get more information and join our community, contact your leader via the link below.",
    s4_cta: "Message your leader",
    final_h: "Ready to start?",
    final_p: "Join The Money Club and start trading with a plan, knowledge and community support.",
    disclaimer: "The Money Club is educational and informational and does not constitute individual investment advice. Trading involves the risk of losing capital."
  }
};

function esc(s){ return String(s==null?"":s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;"); }
var ICONS = [
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 3v18h18"/><path d="m19 9-5 5-4-4-3 3"/></svg>',
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 10 12 5 2 10l10 5 10-5Z"/><path d="M6 12v5c0 1 2.7 2.5 6 2.5s6-1.5 6-2.5v-5"/></svg>',
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>',
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z"/></svg>',
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5a3 3 0 0 0-3 3 3 3 0 0 0-3 3 3 3 0 0 0 1 5 3 3 0 0 0 5 1 3 3 0 0 0 5-1 3 3 0 0 0 1-5 3 3 0 0 0-3-3 3 3 0 0 0-3-3Z"/><path d="M12 5v14"/></svg>',
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m12 2 9 5-9 5-9-5 9-5Z"/><path d="m3 12 9 5 9-5"/><path d="m3 17 9 5 9-5"/></svg>'
];
function href(u){ return u ? esc(u) : "#"; }

function render(lang){
  var t = I18N[lang] || I18N.pl;
  document.documentElement.lang = lang;
  document.querySelectorAll("[data-i]").forEach(function(el){
    var k = el.getAttribute("data-i");
    var v = t[k];
    if (typeof v === "string"){ el.textContent = v; }
  });
  // offer cards
  var off = document.getElementById("offerGrid"); off.innerHTML = "";
  (t.offer||[]).forEach(function(o,i){
    off.innerHTML += '<div class="card reveal"><div class="card-ic">'+(ICONS[i]||"")+'</div><h3>'+esc(o[0])+'</h3><p>'+esc(o[1])+'</p></div>';
  });
  // links — kieruj bezpośrednio na Telegram (Discord jako zapas)
  document.querySelectorAll("[data-discord]").forEach(function(a){ a.href = href(CFG.telegram_link || CFG.discord_link); });
  // active lang buttons
  document.querySelectorAll(".lang-btn").forEach(function(b){ b.classList.toggle("on", b.getAttribute("data-lang")===lang); });
  try { localStorage.setItem("tmc_lang", lang); } catch(e){}
}

function setLang(l){ render(l); }
window.__setLang = setLang;

document.addEventListener("DOMContentLoaded", function(){
  var saved = "pl";
  try { saved = localStorage.getItem("tmc_lang") || "pl"; } catch(e){}
  render(saved);
  var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add("in"); io.unobserve(e.target); } }); }, {threshold:0.12});
  document.querySelectorAll(".reveal").forEach(function(el){ io.observe(el); });
  document.querySelectorAll('a[href^="#"]').forEach(function(a){
    a.addEventListener("click", function(ev){ var id=a.getAttribute("href"); if(id.length>1){ var el=document.querySelector(id); if(el){ ev.preventDefault(); el.scrollIntoView({behavior:"smooth"}); } } });
  });
});
`;

const STYLE = `
*{margin:0;padding:0;box-sizing:border-box}
:root{--bg:#08060f;--bg2:#0e0a1c;--pri:#8b5cf6;--pri2:#a855f7;--gold:#d4af37;--txt:#ece9f5;--mut:#a49dbd;--line:rgba(168,85,247,.16)}
html{scroll-behavior:smooth}
body{font-family:'Plus Jakarta Sans','Segoe UI',system-ui,sans-serif;background:var(--bg);color:var(--txt);line-height:1.6;overflow-x:hidden}
a{color:inherit;text-decoration:none}
.wrap{max-width:1120px;margin:0 auto;padding:0 22px}
.btn{display:inline-flex;align-items:center;gap:8px;padding:14px 26px;border-radius:999px;font-weight:700;font-size:15px;cursor:pointer;border:none;transition:transform .2s ease,box-shadow .2s ease,background .2s ease}
.btn-pri{background:linear-gradient(135deg,var(--pri),var(--pri2));color:#fff;box-shadow:0 10px 30px rgba(139,92,246,.35)}
.btn-pri:hover{transform:translateY(-2px);box-shadow:0 16px 40px rgba(139,92,246,.5)}
.btn-dc{background:#5865F2;color:#fff}
.btn-dc:hover{transform:translateY(-2px);box-shadow:0 14px 34px rgba(88,101,242,.45)}
.btn-out{background:rgba(255,255,255,.04);color:var(--txt);border:1px solid var(--line)}
.btn-out:hover{border-color:var(--pri2);color:#fff}
/* topbar */
.top{position:sticky;top:0;z-index:50;backdrop-filter:blur(16px);background:rgba(8,6,15,.72);border-bottom:1px solid var(--line)}
.top .wrap{display:flex;align-items:center;justify-content:space-between;height:66px}
.brand{display:flex;align-items:center;gap:10px}
.brand img{height:40px;width:40px;border-radius:9px;object-fit:cover}
.brand b{font-size:16px;letter-spacing:.5px}
.top-r{display:flex;align-items:center;gap:14px}
.lang{display:flex;gap:4px;background:rgba(255,255,255,.05);border:1px solid var(--line);border-radius:999px;padding:3px}
.lang-btn{background:none;border:none;color:var(--mut);font-weight:700;font-size:12px;padding:6px 12px;border-radius:999px;cursor:pointer;transition:.2s}
.lang-btn.on{background:linear-gradient(135deg,var(--pri),var(--pri2));color:#fff}
.top .btn{padding:10px 20px;font-size:14px}
@media(max-width:640px){.top-join{display:none}}
/* hero */
.hero{position:relative;padding:90px 0 80px;text-align:center;overflow:hidden}
.hero::before{content:"";position:absolute;inset:0;background:radial-gradient(60% 50% at 50% 0%,rgba(139,92,246,.28),transparent 70%),radial-gradient(40% 40% at 80% 20%,rgba(168,85,247,.16),transparent 60%);pointer-events:none}
.hero-logo{width:120px;height:120px;border-radius:26px;object-fit:cover;margin:0 auto 26px;box-shadow:0 20px 60px rgba(139,92,246,.4);position:relative}
.badge{display:inline-block;font-size:12px;font-weight:800;letter-spacing:2px;color:var(--pri2);border:1px solid var(--line);padding:8px 16px;border-radius:999px;background:rgba(139,92,246,.08);margin-bottom:22px}
.hero h1{font-size:clamp(38px,7vw,72px);font-weight:800;letter-spacing:-1px;background:linear-gradient(120deg,#fff 20%,var(--pri2));-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent;position:relative}
.hero p{max-width:640px;margin:20px auto 34px;color:var(--mut);font-size:clamp(16px,2.4vw,20px);position:relative}
.hero-cta{display:flex;gap:14px;justify-content:center;flex-wrap:wrap;position:relative}
/* sections */
section{padding:70px 0;position:relative}
.eyebrow{color:var(--pri2);font-weight:800;letter-spacing:2px;font-size:12px;text-transform:uppercase}
h2{font-size:clamp(26px,4vw,40px);font-weight:800;margin:10px 0 8px;letter-spacing:-.5px}
.sec-lead{color:var(--mut);max-width:640px;font-size:16px;margin-bottom:36px}
.grid{display:grid;grid-template-columns:repeat(3,1fr);gap:22px}
@media(max-width:860px){.grid{grid-template-columns:1fr}}
.card{background:linear-gradient(160deg,rgba(255,255,255,.05),rgba(255,255,255,.015));border:1px solid var(--line);border-radius:20px;padding:32px 30px;transition:transform .3s ease,border-color .3s ease,box-shadow .3s ease}
.card:hover{transform:translateY(-5px);border-color:var(--pri2);box-shadow:0 22px 50px rgba(139,92,246,.22)}
.card-ic{width:58px;height:58px;border-radius:16px;display:flex;align-items:center;justify-content:center;background:linear-gradient(135deg,var(--pri),var(--pri2));margin-bottom:20px;box-shadow:0 12px 28px rgba(139,92,246,.45)}
.card-ic svg{width:28px;height:28px;color:#fff}
.card h3{font-size:22px;margin-bottom:10px}
.card p{color:var(--mut);font-size:16px;line-height:1.65}
/* steps */
.step{display:flex;gap:22px;padding:28px 0;border-top:1px solid var(--line)}
.step-n{flex:0 0 56px;height:56px;width:56px;border-radius:16px;display:flex;align-items:center;justify-content:center;font-weight:800;font-size:22px;background:linear-gradient(135deg,var(--pri),var(--pri2));color:#fff;box-shadow:0 10px 26px rgba(139,92,246,.4)}
.step-b{flex:1}
.step-b h3{font-size:21px;margin-bottom:8px}
.step-b p{color:var(--mut);margin-bottom:16px}
.step-b .btn{margin-top:4px}
.tqbox{display:flex;align-items:center;gap:16px;flex-wrap:wrap;margin-bottom:16px;padding:16px 20px;border:1px solid var(--line);border-radius:14px;background:rgba(255,255,255,.03)}
.tqlogo{display:inline-flex;align-items:center;font-size:26px;font-weight:800;letter-spacing:-.5px;color:#fff}
.tqlogo .tqlogo-b{color:#fff}
.tqlogo-img{height:34px;object-fit:contain}
.tqdot{width:10px;height:10px;border-radius:50%;background:#e42320;margin-left:4px;margin-bottom:14px}
.formcard{margin-top:14px;padding:20px 22px;border:1px solid var(--line);border-radius:14px;background:rgba(139,92,246,.05)}
.formcard h4{font-size:15px;margin-bottom:12px;color:#fff}
.formcard ol{margin-left:18px;color:var(--mut);font-size:15px}
.formcard li{margin-bottom:7px}
/* promo */
.promo-grid{display:grid;grid-template-columns:repeat(2,1fr);gap:18px}
@media(max-width:720px){.promo-grid{grid-template-columns:1fr}}
.promo{background:linear-gradient(160deg,rgba(139,92,246,.12),rgba(255,255,255,.02));border:1px solid var(--line);border-radius:18px;padding:26px;position:relative;overflow:hidden}
.promo::after{content:"";position:absolute;right:-30px;top:-30px;width:120px;height:120px;background:radial-gradient(circle,rgba(168,85,247,.35),transparent 70%)}
.promo-pct{font-size:34px;font-weight:800;color:var(--pri2)}
.promo-code{display:inline-block;margin:10px 0 12px;font-family:'JetBrains Mono',monospace;font-weight:700;letter-spacing:1px;background:rgba(255,255,255,.06);border:1px dashed var(--pri2);color:#fff;padding:7px 14px;border-radius:10px}
.promo p{color:var(--mut);font-size:14px;position:relative}
/* final */
.final{text-align:center;background:radial-gradient(60% 100% at 50% 0%,rgba(139,92,246,.18),transparent 70%);border-top:1px solid var(--line);border-bottom:1px solid var(--line)}
.final h2{margin-bottom:12px}
.final p{color:var(--mut);max-width:560px;margin:0 auto 28px}
.final .hero-cta{margin-top:0}
/* footer */
footer{padding:40px 0;text-align:center}
footer .wrap{color:var(--mut);font-size:13px}
footer .fbrand{display:flex;align-items:center;justify-content:center;gap:10px;margin-bottom:18px;font-weight:800;color:#fff}
footer img{height:30px;width:30px;border-radius:8px}
/* reveal */
.reveal{opacity:0;transform:translateY(24px);transition:opacity .6s ease,transform .6s ease}
.reveal.in{opacity:1;transform:none}
`;

export function buildLandingHtml(cfg) {
  const CFG = { ...DEFAULT_LANDING, ...(cfg || {}) };
  const cfgJson = JSON.stringify(CFG).replace(/</g, "\\u003c");
  const head = `<!DOCTYPE html>
<html lang="pl">
<head>
<meta charset="UTF-8"/>
<meta name="viewport" content="width=device-width,initial-scale=1"/>
<title>The Money Club — Dołącz</title>
<meta name="description" content="The Money Club (TMC) — akademia tradingu, sygnały i społeczność. Dołącz do naszej społeczności."/>
<link rel="preconnect" href="https://fonts.googleapis.com"/>
<link href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;600;700;800&family=JetBrains+Mono:wght@700&display=swap" rel="stylesheet"/>
<style>${STYLE}</style>
</head>
<body>`;

  const body = `
<header class="top">
  <div class="wrap">
    <div class="brand"><img src="${TMC_LOGO}" alt="The Money Club"/><b>THE MONEY CLUB</b></div>
    <div class="top-r">
      <div class="lang">
        <button class="lang-btn" data-lang="pl" onclick="__setLang('pl')">PL</button>
        <button class="lang-btn" data-lang="en" onclick="__setLang('en')">EN</button>
      </div>
      <a class="btn btn-pri top-join" href="#join" data-i="nav_join">Dołącz</a>
    </div>
  </div>
</header>

<section class="hero">
  <div class="wrap">
    <img class="hero-logo" src="${TMC_LOGO}" alt="The Money Club"/>
    <div class="badge" data-i="hero_badge"></div>
    <h1>The Money Club</h1>
    <p data-i="hero_tag"></p>
    <div class="hero-cta">
      <a class="btn btn-pri" href="#join" data-i="hero_cta1"></a>
      <a class="btn btn-dc" data-discord target="_blank" rel="noopener" data-i="hero_cta2"></a>
    </div>
  </div>
</section>

<section id="about">
  <div class="wrap">
    <div class="eyebrow">TMC</div>
    <h2 data-i="about_h"></h2>
    <p class="sec-lead" data-i="about_p"></p>
  </div>
</section>

<section id="offer" style="padding-top:0">
  <div class="wrap">
    <div class="eyebrow">Value</div>
    <h2 data-i="offer_h"></h2>
    <div class="grid" id="offerGrid" style="margin-top:26px"></div>
  </div>
</section>

<section id="join">
  <div class="wrap">
    <div class="eyebrow">Onboarding</div>
    <h2 data-i="join_h"></h2>
    <div style="margin-top:20px">
      <div class="step reveal">
        <div class="step-b" style="text-align:center">
          <h3 data-i="s4_h"></h3>
          <p data-i="s4_p"></p>
          <a class="btn btn-dc" data-discord target="_blank" rel="noopener" data-i="s4_cta"></a>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="final">
  <div class="wrap">
    <h2 data-i="final_h"></h2>
    <p data-i="final_p"></p>
    <div class="hero-cta">
      <a class="btn btn-dc" data-discord target="_blank" rel="noopener"><span data-i="s4_cta"></span></a>
    </div>
  </div>
</section>

<footer>
  <div class="wrap">
    <div class="fbrand"><img src="${TMC_LOGO}" alt="TMC"/> THE MONEY CLUB</div>
    <div data-i="disclaimer"></div>
    <div style="margin-top:14px;opacity:.6">© The Money Club</div>
  </div>
</footer>

<script>var CFG=${cfgJson};
${PAGE_JS}
</script>
</body>
</html>`;

  return head + body;
}

export const AI_PLACEHOLDER = `<!doctype html><html lang="pl"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><title>Strona w przygotowaniu</title></head><body style="margin:0;min-height:100vh;display:flex;align-items:center;justify-content:center;background:#08060f;color:#fff;font-family:system-ui,sans-serif;text-align:center;padding:24px"><div><h1 style="font-size:28px;margin:0 0 10px">Strona w przygotowaniu</h1><p style="color:#9aa3b2;max-width:420px">Ta strona jest tworzona przez AI. Wejdź w panel „Strona WWW", opisz co ma zawierać i kliknij „Wygeneruj stronę".</p></div></body></html>`;
